import { Modal } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { WitnessSigningStep } from '@dealstack/frontend/shared/components/EidEasySigningModal/steps/WitnessSigningStep';

interface Props {
	isOpen: boolean;
	isLoading: boolean;
	initialEmail?: string;
	onClose: () => void;
	onSubmit: (email: string) => void;
}

/** Nominates or updates a witness after signing, with the same eligibility checks as before signing. */
export const WitnessEmailModal = ({
	isOpen,
	isLoading,
	initialEmail,
	onClose,
	onSubmit,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<Modal
			opened={isOpen}
			onClose={onClose}
			title={tMipManage('documents_page.witness.modal_title')}
			centered
			size="lg"
		>
			<WitnessSigningStep
				defaultEmail={initialEmail}
				isSubmitting={isLoading}
				submitLabel={tMipManage('documents_page.witness.send')}
				onContinue={onSubmit}
			/>
		</Modal>
	);
};
